export default __webpack_public_path__ + "static/media/wind-and-solar-combo-e1459763643994-1-point-5-768x512.0ec7291d.jpg";